import React from 'react';
import { testIdentifiers } from 'utils/testIdentifiers';
import styled from 'styled-components/native';
const ImageWrapper = styled.View<{
  backgroundColor?: string;
  showBorder: boolean;
}>`
  padding: 8px;
  border-radius: 25px;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : 'transparent'};
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border: ${({ showBorder }) => (showBorder ? 2 : 0)}px solid gray;
  ${(p) => p.showBorder && 'border-style: dashed'}
`;

const CircleImageWrapper = ({
  testIdentifiersPrefix,
  backgroundColor,
  ImageComponent,
  showBorder = false,
}: {
  testIdentifiersPrefix?: string;
  backgroundColor?: string;
  ImageComponent: React.FC;
  showBorder?: boolean;
}) => {
  return (
    <ImageWrapper
      showBorder={showBorder}
      {...testIdentifiers(`${testIdentifiersPrefix}circle-image-wrapper`)}
      backgroundColor={backgroundColor}>
      <ImageComponent />
    </ImageWrapper>
  );
};

export default CircleImageWrapper;
